import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import useApiManager from '../../utils/Api/apiManager';

const UsersAutoComplete = ({ setUserId, userId, small = false, fullWidth = true, disabled = false }) => {
    const [leadOwnerOptions, setLeadOwnerOptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const { get } = useApiManager();

    useEffect(() => {
        const fetchAndSetData = async () => {
            try {
                const data = await get('/users');
                const options = data.map(user => ({
                    label: `${user.firstName} ${user.lastName}`,
                    value: user.id,
                }));

                setLeadOwnerOptions(options);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchAndSetData();
    }, []);

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: small ? '40px' : '56px',
            height: small ? '40px' : '56px',
            padding: '0px 8px',
            borderRadius: '4px',
            fontSize: '16px',
            borderColor: state.isFocused ? '#1976d2' : provided.borderColor,
            boxShadow: state.isFocused ? '0 0 0 2px rgba(25, 118, 210, 0.2)' : 'none',
            '&:hover': {
                borderColor: '#1976d2',
            },
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '2px 8px',
        }),
        input: (provided) => ({
            ...provided,
            fontSize: '16px',
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 10,
            backgroundColor: '#fff',
            borderRadius: '4px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? '#f0f0f0' : '#fff',
            color: '#000',
            padding: '8px 12px',
        }),
    };

    return (
        <div style={{ width: fullWidth ? '100%' : 'auto' }}>
            <Select
                isLoading={loading}
                isClearable
                required
                options={leadOwnerOptions}
                value={leadOwnerOptions.find(option => option.value === userId) || null}
                onChange={(selectedOption) => setUserId(selectedOption ? selectedOption.value : '')}
                placeholder="Select Owner"
                styles={customStyles}
                isDisabled={disabled}
            />
        </div>
    );
};

export default UsersAutoComplete;
